module.exports = [
  {
    title: 'Dashboard',
    url: 'Dashboard',
    icon: 'home'
  },
  {
    slug: 'orders',
    title: {
      de: 'Bestellungen',
      en: 'Orders'
    },
    url: 'Orders',
    subViews: [
      'OrderDetails'
    ],
    icon: 'inbox'
  },
  {
    slug: 'projects',
    title: {en: 'Drafts', de: 'Entwürfe'},
    url: 'Projects',
    index: 'tag:-Approval,status:0',
    subViews: [
      'ProjectDetails',
      'UploadStl'
    ],
    icon: 'cog',
    indicator: {
      api: 'project/',
      params: {
        tag: '-Approval',
        status: 0,
      }
    }
  },
  /*{
    slug: 'approvals',
    title: {en: 'Approvals', de: 'Freigabe'},
    url: 'Projects',
    index: 'tag:Approval',
    subViews: [
    ],
    icon: 'cog',
    indicator: {
      api: 'project/',
      params: {
        tag: 'Approval',
        status: 3,
      }
    }
  },*/
  {
    title: 'Nachrichten',
    url: 'Messages',
    icon: 'comments'
  }
];
